module.exports = __webpack_public_path__ + "4fc8d48269b2a3b8d60fc48d005c0032.pdf";